import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconZap"><Path d="M20.5 8.5H13.5V1.75L3.5 15.5H10.5V22.25L20.5 8.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconZap;
